<template>
    <div class="login-wrap">
        <div class="wrapper">
            <div class="inner-title">
                <img class="title-pic" src="@/assets/imgs/logo_shulan.png" />
                <div class="QRcode-wrap">
                    <el-popover placement="bottom" width="256" trigger="hover">
                        <div class="QR-content">
                            <div>Android下载二维码</div>
                            <div>
                                <img src="@/assets/imgs/q2vR-An.png" alt="" />
                            </div>
                            <div class="word-small">请使用手机扫描二维码下载</div>
                        </div>
                        <el-button slot="reference">
                            <i class="iconfont icon-Android"></i>
                            Android下载
                        </el-button>
                    </el-popover>
                    <el-popover placement="bottom" width="256" trigger="hover">
                        <div class="QR-content">
                            <div>iphone下载二维码</div>
                            <div>
                                <img src="@/assets/imgs/E9xD-ios.png" alt="" />
                            </div>
                            <div class="word-small">请使用手机扫描二维码下载</div>
                        </div>
                        <el-button slot="reference">
                            <i class="iconfont icon-iPhone"></i>
                            iphone下载
                        </el-button>
                    </el-popover>
                </div>
            </div>
            <div class="inner-wrap">
                <div class="login-newbg"></div>

                <div class="content-layout">
                    <div class="inner">
                        <!-- <div class="title">
                            <div class="title-tab" :class="[{ 'tab-choosed': tabChoosed == 'workNumber' }]" @click="changeTab('workNumber')">工号密码登录</div>
                            <div class="title-tab" :class="[{ 'tab-choosed': tabChoosed == 'phone' }]" @click="changeTab('phone')">手机号登录</div>
                        </div> -->
                        <div class="title">
                            <div style="width:100%;line-height: 60px;color: #666;font-size: 16px;">工号密码登录</div>
                        </div>
                        <el-form :model="userForm" ref="userForm" :rules="phoneRules" v-loading="loading" class="login-ruleForm" v-show="tabChoosed == 'workNumber'">
                            <div class="user-error" v-if="errorVisible">
                                <i class="iconfont icon-jinggaochacha"></i>
                                <span class="error-text">工号或密码不正确!</span>
                            </div>
                            <div class="user-error" v-if="noauth">
                                <i class="iconfont icon-jinggaochacha"></i>
                                <span class="error-text">用户暂无权限请联系管理员</span>
                            </div>
                            <div class="user-no-error" v-if="!noauth && !errorVisible"></div>
                            <el-form-item prop="userName">
                                <el-input
                                    v-model="userForm.userName"
                                    placeholder="请输入工号"
                                    @keyup.enter.native="submitForm('userForm', 'password')"
                                    clearable
                                    prefix-icon="iconfont icon-user2"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="password" :rules="[{ required: true, message: '请输入密码', trigger: 'change' }]">
                                <el-input
                                    v-model="userForm.password"
                                    auto-complete="off"
                                    type="password"
                                    @keyup.enter.native="submitForm('userForm', 'password')"
                                    placeholder="请输入密码"
                                    clearable
                                    prefix-icon="iconfont icon-password"
                                ></el-input>
                            </el-form-item>
                            <el-form-item v-if="!newisSliderShow" prop="verificationCode">
                                <el-input v-model="userForm.verificationCode" placeholder="请输入验证码" clearable prefix-icon="iconfont icon-VerificationCode_huaban"></el-input>
                                <div class="newget-code" :class="[{ 'click-code': newcodeCanClick }]" @click="newgetCode()">{{ newcodeStr }}</div>
                            </el-form-item>
                            <el-button type="primary" class="submit-btn" @click="submitForm('userForm', 'password')">登录</el-button>
                            <div class="checkbox-wrap">
                                <el-checkbox v-model="checked">记住密码</el-checkbox>
                            </div>
                        </el-form>
                        <el-form :model="phoneForm" :rules="phoneRules" ref="phoneForm" v-loading="phoneLoading" class="login-ruleForm" v-show="tabChoosed == 'phone'">
                            <div class="user-error" v-if="errorVisible">
                                <i class="iconfont icon-jinggaochacha"></i>
                                <span class="error-text">手机号或者验证码不正确!</span>
                            </div>
                            <div class="user-error" v-if="noauth">
                                <i class="iconfont icon-jinggaochacha"></i>
                                <span class="error-text">用户暂无权限请联系管理员</span>
                            </div>
                            <div class="user-no-error" v-if="!noauth && !errorVisible"></div>
                            <el-form-item prop="phone">
                                <el-input
                                    v-model="phoneForm.phone"
                                    placeholder="请输入手机号"
                                    @keyup.enter.native="submitForm('phoneForm', 'phone')"
                                    clearable
                                    prefix-icon="iconfont icon-phone1"
                                ></el-input>
                            </el-form-item>
                            <password-side v-show="isSliderShow" @success="successSlider" :is-slider-show="isSliderShow && isSliderVaild" />

                            <el-form-item v-if="!isSliderShow" prop="code">
                                <el-input
                                    v-model="phoneForm.code"
                                    placeholder="请输入验证码"
                                    @keyup.enter.native="submitForm('phoneForm', 'phone')"
                                    clearable
                                    prefix-icon="iconfont icon-VerificationCode_huaban"
                                ></el-input>
                                <div class="get-code" :class="[{ 'click-code': codeCanClick }]" @click="getCode()">{{ codeStr }}</div>
                            </el-form-item>
                            <el-button type="primary" class="submit-btn" @click="submitForm('phoneForm', 'phone')">登录</el-button>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="bottom-wrap">
                <div class="bottom">
                    <div class="bottom-item">
                        <img src="@/assets/imgs/huahzhuologo.png" />
                    </div>
                    <div class="bottom-item bottom-text">
                        华卓科技版权所有 &copy; 2014 |
                        <a class="bottom-link" href="http://www.wowjoy.cn" target="_blank">http://www.wowjoy.cn</a>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="修改密码"
            :visible.sync="dialogVisible"
            width="560px"
            :show-close="false"
            :before-close="handleBeforeClose"
            :close-on-click-modal="false"
            custom-class="password-dialog"
        >
            <div class="password-icon-tips">
                <i class="el-icon-warning"></i>
                <p class="tips-text">您的密码强度过低，请修改密码！</p>
            </div>
            <el-form :model="passwordForm" ref="passwordForm" v-loading="passwordLoading" label-width="100px" :rules="passwordRules" class="password-passwordForm">
                <el-form-item label="工号">
                    <el-input v-model="userForm.userName" class="form-input" disabled></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-popover placement="right-start" width="236px" popper-class="pass-popover-hover" trigger="hover">
                        <div class="pass-length">
                            <i class="el-icon-circle-check" v-if="passShow"></i>
                            <i class="el-icon-circle-close" v-else></i>
                            <p class="pass-text">长度为8-32个字符</p>
                        </div>
                        <div class="pass-rule">
                            <i class="el-icon-circle-check" v-if="ruleShow"></i>
                            <i class="el-icon-circle-close" v-else></i>
                            <p class="pass-text">数字、大小写字母以及特殊字符至少包含两种</p>
                        </div>
                        <el-input v-model="passwordForm.newPassword" slot="reference" class="form-input" type="password"></el-input>
                    </el-popover>
                </el-form-item>

                <el-form-item label="确认新密码" prop="againPassword">
                    <el-popover placement="right-start" width="236px" popper-class="pass-popover-hover" trigger="hover">
                        <div class="pass-length">
                            <i class="el-icon-circle-check" v-if="passShow2"></i>
                            <i class="el-icon-circle-close" v-else></i>
                            <p class="pass-text">长度为8-32个字符</p>
                        </div>
                        <div class="pass-rule">
                            <i class="el-icon-circle-check" v-if="ruleShow2"></i>
                            <i class="el-icon-circle-close" v-else></i>
                            <p class="pass-text">数字、大小写字母以及特殊字符至少包含两种</p>
                        </div>
                        <el-input v-model="passwordForm.againPassword" slot="reference" class="form-input" type="password"></el-input>
                    </el-popover>
                </el-form-item>

                <el-form-item style="padding-bottom:30px;">
                    <el-button type="primary" class="confirm-btn" @click="handleConfirmLogin('passwordForm')">确 定</el-button>
                    <el-button class="cancle-btn" @click="handleCancleLogin">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { SM4 } from 'gm-crypto';
import { postVerification, putChangeWeakPassword, postByStaffNo, postBycode, oauthTokenLogin } from '@/api/login';
import PasswordSide from '@/components/PasswordSide';
import { getUserName, getPassword, setUserName, setPassword, removeToken } from '@/utils/auth';
export default {
    data() {
        const checkPhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号！'));
            } else {
                const phoneTest = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (phoneTest.test(value)) {
                    callback();
                } else {
                    callback(new Error('手机号码格式不正确！'));
                }
            }
        };
        const checkUser = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入工号！'));
            } else {
                if (value.length > 10) {
                    callback(new Error('请输入正确的工号！'));
                } else {
                    callback();
                }
            }
        };
        const checkPassword = (rule, value, callback) => {
            if (value === '') {
                this.passShow = false;
                this.ruleShow = false;
                callback(new Error('请输入新密码！'));
            } else {
                if (value.length > 32 || value.length < 8) {
                    this.passShow = false;
                    callback(new Error('密码格式错误!'));
                } else {
                    this.passShow = true;
                    // 判断密码强弱
                    let modes = this.checkPasswordStrong(value);
                    if (modes < 2) {
                        this.ruleShow = false;
                        callback(new Error('密码格式错误!'));
                    } else {
                        this.ruleShow = true;
                        callback();
                    }
                }
            }
        };

        const checkAgainPassword = (rule, value, callback) => {
            if (value === '') {
                this.passShow2 = false;
                this.ruleShow2 = false;
                callback(new Error('请再次输入新密码'));
            } else if (value !== this.passwordForm.newPassword) {
                checkTipsAgainPassword(value);
                callback(new Error('两次输入密码不一致!'));
            } else {
                if (value.length > 32 || value.length < 8) {
                    this.passShow2 = false;
                    callback(new Error('密码格式错误!'));
                } else {
                    this.passShow2 = true;
                    // 判断密码强弱
                    let modes = this.checkPasswordStrong(value);
                    if (modes < 2) {
                        this.ruleShow2 = false;
                        callback(new Error('密码格式错误!'));
                    } else {
                        this.ruleShow2 = true;
                        callback();
                    }
                }
            }
        };
        const checkTipsAgainPassword = value => {
            if (value.length > 32 || value.length < 8) {
                this.passShow2 = false;
            } else {
                this.passShow2 = true;
            }
            // 判断密码强弱
            let modes = this.checkPasswordStrong(value);
            if (modes < 2) {
                this.ruleShow2 = false;
            } else {
                this.ruleShow2 = true;
            }
        };

        return {
            newisSliderShow: false,
            loading: false,
            phoneLoading: false,
            checked: false,
            errorVisible: false,
            noauth: false,
            dialogVisible: false,
            passShow: false,
            ruleShow: false,
            passShow2: false,
            ruleShow2: false,
            passwordLoading: false,
            passwordForm: {
                newPassword: '',
                againPassword: ''
            },
            userForm: {
                userName: '',
                password: '',
                verificationCode: ''
            },
            phoneForm: {
                phone: '',
                code: ''
            },
            phoneRules: {
                phone: [{ required: true, validator: checkPhone, trigger: 'change' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'change' }],
                userName: [{ required: true, validator: checkUser, trigger: 'change' }]
            },
            passwordRules: {
                newPassword: [{ required: true, validator: checkPassword, trigger: 'change' }],
                againPassword: [{ required: true, validator: checkAgainPassword, trigger: 'change' }]
            },
            tabChoosed: 'workNumber',
            sliderValue: 0,
            codeStr: '获取验证码',
            newcodeStr: '获取验证码',
            codeCanClick: true,
            newcodeCanClick: true,
            isSliderShow: true,
            isSliderVaild: false,
            iuid: '',
            message: '抖音直播大卖！',
            key: 'c2xobHd5eTIwMjMl', //密钥,后期用token和后端对接，根据项目选择key
            encryptStr: '', //密文
            decryptStr: '', //解密
            SM4encryptStr: '',
            SM4decryptStr: ''
        };
    },
    components: {
        PasswordSide
    },
    computed: {
        superAdmin() {
            return this.$store.getters.userInfo.roles.findIndex(item => item.roleName === '超级管理员');
        }
    },
    methods: {
        // 关闭Dialog前的回调
        async handleBeforeClose(done) {
            await this.$store.dispatch('user/logout');
            done();
        },
        // 取消修改密码
        async handleCancleLogin() {
            await this.$store.dispatch('user/logout');
            this.dialogVisible = false;
        },
        // 确认修改密码
        handleConfirmLogin(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.handleChangePassword();
                } else {
                    return false;
                }
            });
        },
        // 用户00888，重置密码接口
        async resertPassword() {
            let params = {
                account: this.userForm.userName,
                iuid: 'e0cd139c1c74482d90cf8b4169eec8cb',
                newPassword: '123456',
                oldPassword: this.userForm.password
            };
            await putChangeWeakPassword(params);
        },
        // 修改密码
        async handleChangePassword() {
            let params = {
                account: this.userForm.userName,
                iuid: this.iuid,
                newPassword: this.passwordForm.newPassword,
                oldPassword: this.userForm.password
            };
            this.passwordLoading = true;
            const { results } = await putChangeWeakPassword(params);
            if (results === 'OK') {
                this.$message({
                    message: '修改密码成功，请重新登录！',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                });
            } else {
                this.$message({
                    message: '修改密码不成功，请联系管理员！',
                    customClass: 'hos-message--error',
                    iconClass: 'el-icon-error',
                    duration: '2000'
                });
            }
            await this.$store.dispatch('user/logout');
            this.passwordLoading = false;
            this.dialogVisible = false;
        },
        successSlider() {
            this.isSliderShow = false;
            this.isSliderVaild = false;
        },
        changeTab(type) {
            this.tabChoosed = type;
            if (type === 'phone') {
                this.$refs['userForm'].resetFields();
            } else if (type === 'workNumber') {
                this.$refs['phoneForm'].resetFields();
            }
            this.errorVisible = false;
            this.noauth = false;
        },
        getCode() {
            if (this.isSliderShow) {
                return;
            }
            if (!this.codeCanClick) {
                return;
            }
            const phoneTest = /^[1][3,4,5,7,8,9][0-9]{9}$/;
            if (!this.phoneForm.phone || !phoneTest.test(this.phoneForm.phone)) {
                return;
            }
            let time = 60;
            this.codeStr = time + 's';
            this.codeCanClick = false;
            let timer = setInterval(() => {
                time--;
                if (time < 1) {
                    clearInterval(timer);
                    this.codeStr = '获取验证码';
                    this.codeCanClick = true;
                } else {
                    this.codeStr = time + 's';
                }
            }, 1000);
            this.handlePostCode();
        },
        newgetCode() {
            if (this.newisSliderShow) {
                return;
            }
            if (!this.codeCanClick) {
                return;
            }
            if (!this.userForm.userName) {
                this.$message.error('请输入工号');
                return;
            }
            let time = 60;
            this.newcodeStr = time + 's';
            this.newcodeCanClick = false;
            let timer = setInterval(() => {
                time--;
                if (time < 1) {
                    clearInterval(timer);
                    this.newcodeStr = '获取验证码';
                    this.newcodeCanClick = true;
                } else {
                    this.newcodeStr = time + 's';
                }
            }, 1000);
            this.newhandlePostCode();
        },
        async handlePostCode() {
            const param = {
                phone: this.phoneForm.phone,
                signName: '树兰医疗'
            };
            if (!this.phoneForm.phone) {
                debugger;
                this.$message.error('请输入手机号');
                return;
            }
            await postBycode(param);
        },
        //发送验证码
        newhandlePostCode() {
            let params = {
                staffNo: this.userForm.userName
            };
            postByStaffNo(params).then(res => {});
        },
        // 登录
        submitForm(formName, type) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (type === 'password') {
                        this.handleLogin(); // 工号登录
                    }
                    if (type === 'phone') {
                        this.handleLoginByText(); // 手机号登录
                    }
                } else {
                    if (this.isSliderShow) {
                        this.isSliderVaild = true;
                    }
                    this.errorVisible = false;
                    this.noauth = false;
                    return false;
                }
            });
        },
        // 工号登录
        handleLogin() {
            this.loading = true;
            let newuserForm = {
                userName: this.handleSM4Encrypt(this.userForm.userName),
                password: this.handleSM4Encrypt(this.userForm.password),
                verificationCode: this.handleSM4Encrypt(this.userForm.verificationCode),
                grant_type: this.handleSM4Encrypt('password')
            };

            this.$store
                .dispatch('user/login', newuserForm)
                .then(res => {
                    if (res === 'error') {
                        this.errorVisible = true;
                        this.noauth = false;
                        this.loading = false;
                    } else {
                        this.handleCheckRoles();
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 手机号登录
        handleLoginByText() {
            if (this.isSliderShow) {
                this.isSliderVaild = true;
                return;
            }
            this.phoneLoading = true;
            let newphoneForm = {
                username: this.handleSM4Encrypt(this.phoneForm.phone),
                grant_type: this.handleSM4Encrypt('dynamic_password'),
                password: this.handleSM4Encrypt(this.phoneForm.code)
            };
            this.$store
                .dispatch('user/message', newphoneForm)
                .then(res => {
                    if (res === 'error') {
                        this.errorVisible = true;
                        this.noauth = false;
                        this.phoneLoading = false;
                    } else {
                        this.handleCheckRoles();
                    }
                })
                .catch(error => {
                    debugger;
                    console.log(error);
                    this.phoneLoading = false;
                });
        },
        handleCheckRoles() {
            this.$store
                .dispatch('user/getInfo')
                .then(res => {
                    if (res === 'noRoles') {
                        this.errorVisible = false;
                        this.noauth = true;
                        this.loading = false;
                        this.phoneLoading = false;
                        removeToken();
                    } else {
                        if (this.tabChoosed === 'workNumber') {
                            // 先判断密码强弱，如果弱密码，则修改密码
                            let modes = this.checkPasswordStrong(this.userForm.password);
                            if (modes < 2) {
                                this.iuid = res.iuid;
                                this.loading = false;
                                this.dialogVisible = true;
                                this.passwordForm.newPassword = '';
                                this.passwordForm.againPassword = '';
                                if (this.$refs['passwordForm']) {
                                    this.$refs['passwordForm'].resetFields();
                                }
                            } else {
                                this.hanldeGoList();
                            }
                        } else {
                            this.hanldeGoList();
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.phoneLoading = false;
                });
        },
        hanldeGoList() {
            // this.resertPassword() // 重置密码
            if (this.checked) {
                let flag = getUserName() && getPassword();
                if (!flag) {
                    setUserName(this.userForm.userName);
                    setPassword(this.userForm.password);
                }
            } else {
                setUserName('');
                setPassword('');
            }
            if (this.superAdmin === -1) {
                this.$router.push('/counsel/consultingReply');
            } else {
                this.$router.push('/hospital/hospitalList');
            }
            this.$store.dispatch('user/ChooseHospital', 'doctor');
        },
        // 判断密码强弱
        checkPasswordStrong(password) {
            let modes = 0;
            if (/\d/.test(password)) {
                // 数字
                modes++;
            }
            if (/[a-z]/.test(password) || /[A-Z]/.test(password)) {
                // 大小写
                modes++;
            }
            if (/\W/.test(password)) {
                // 特殊字符
                modes++;
            }
            return modes;
        },
        // SM4加密解密key需要转为32位16进制数
        stringToHex(str) {
            let val = '';
            for (let i = 0; i < str.length; i++) {
                val += str.charCodeAt(i).toString(16);
            }
            return val;
        },
        // SM4加密
        handleSM4Encrypt(data) {
            this.key = this.key;
            let SM4encryptStr = SM4.encrypt(data, this.stringToHex(this.key), {
                inputEncoding: 'utf8',
                outputEncoding: 'base64'
            });
            return SM4encryptStr;
        },
        // SM4解密
        handleSM4Decrypt(data) {
            this.key = this.key;
            let SM4decryptStr = SM4.decrypt(data, this.stringToHex(this.key), {
                inputEncoding: 'base64',
                outputEncoding: 'utf8'
            });
            return SM4decryptStr;
        }
    },
    mounted() {
        if (getUserName() && getPassword()) {
            this.userForm.userName = getUserName();
            this.userForm.password = getPassword();
            this.checked = true;
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.QR-content {
    text-align: center;
    padding: 18px 0px;
    div {
        font-family: PingFang-SC-Medium;
        font-size: 18px;
        color: #666666;
        line-height: 18px;
        img {
            display: block;
            width: 150px;
            height: 150px;
            margin: 30px auto;
            margin-bottom: 16px;
        }
    }
    .word-small {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #999999;
        line-height: 14px;
    }
}
.login-wrap {
    overflow: auto;
    height: 100%;
    @media screen and (max-width: 1380px) {
        .inner-pic {
            left: 2%;
        }
        .inner {
            right: 10%;
        }
    }
    @media screen and (min-width: 1381px) and (max-width: 1600px) {
        .inner-pic {
            left: 10%;
        }
        .inner {
            right: 10%;
        }
    }
    @media screen and (min-width: 1601px) {
        .inner-pic {
            left: 15%;
        }
        .inner {
            right: 15%;
        }
    }
    // position: fixed;
    // top: 0;
    // bottom: 0;
    // left: 0;
    // right: 0;
    .wrapper {
        width: 100%;
        height: 100%;
        background: #fff;
        min-width: 1280px;
        .inner-title {
            font-size: 0;
            box-sizing: border-box;
            height: 170px;
            padding: 0 100px 0 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title-pic {
                height: 54px;
                vertical-align: middle;
            }
            .QRcode-wrap {
                .el-button {
                    padding: 10px 20px;
                    font-size: 14px;
                    margin-right: 20px;
                }
            }
        }

        .inner-wrap {
            height: 640px;
            width: 100%;
            font-size: 0;
            position: relative;
        }
        .login-newbg {
            position: absolute;
            z-index: 9;
            top: 0;
            left: 0;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            width: 100%;
            height: 640px;
            background-image: url('../../assets/imgs/homeBackground.png');
        }
        .content-layout {
            height: 640px;
            .inner {
                position: absolute;
                top: 50%;
                bottom: 0;
                margin-top: -176px;
                line-height: 36px;
                display: inline-block;
                vertical-align: middle;
                width: 360px;
                height: 400px;
                background: #ffffff;
                border-radius: 10px;
                z-index: 999;
                .title {
                    text-align: center;
                    font-size: 0;
                    line-height: 32px;
                    display: flex;
                    border-bottom: 1px solid #e6e6e6;
                    .title-tab {
                        font-size: 16px;
                        color: #666;
                        width: 50%;
                        margin-top: 10px;
                        height: 60px;
                        line-height: 60px;
                        font-weight: bold;
                        position: relative;
                        cursor: pointer;
                        &:first-child:before {
                            content: '';
                            height: 30px;
                            width: 2px;
                            position: absolute;
                            right: 0;
                            top: 15px;
                            background-color: #e6e6e6;
                        }
                    }
                    .tab-choosed {
                        color: #06aea6;
                    }
                }

                .login-ruleForm {
                    width: 280px;
                    margin: 0;
                    padding: 0 40px;
                    position: relative;
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 45px;
                        }
                    }
                    .get-code {
                        position: absolute;
                        top: 1px;
                        right: 1px;
                        height: 43px;
                        line-height: 43px;
                        width: 100px;
                        text-align: center;
                        border-left: 1px solid #dcdcdc;
                        background: #f6f6f6;
                        color: #999999;
                        font-size: 14px;
                        cursor: not-allowed;
                    }
                    .newget-code {
                        position: absolute;
                        top: 1px;
                        right: 1px;
                        height: 38px;
                        line-height: 43px;
                        width: 100px;
                        text-align: center;
                        border-left: 1px solid #dcdcdc;
                        background: #f6f6f6;
                        color: #999999;
                        font-size: 14px;
                        cursor: not-allowed;
                    }
                    .click-code {
                        background: #fff;
                        color: #666;
                        cursor: pointer;
                    }
                    .el-input__prefix {
                        top: 2px;
                        left: 13px;
                        color: #ccc;
                        .iconfont {
                            font-size: 18px;
                        }
                    }
                    .el-input__clear {
                        font-size: 16px;
                        color: #909399;
                    }
                    .is-required {
                        .el-input__inner {
                            height: 45px;
                            border-radius: 0;
                            width: 280px;
                            padding-left: 45px;
                            font-size: 14px;
                            border: 1px solid #dcdcdc;
                        }

                        input::-webkit-input-placeholder,
                        textarea::-webkit-input-placeholder {
                            /* WebKit browsers */
                            color: #666;
                        }
                        input:-moz-placeholder,
                        textarea:-moz-placeholder {
                            /* Mozilla Firefox 4 to 18 */
                            color: #666;
                        }
                        input::-moz-placeholder,
                        textarea::-moz-placeholder {
                            /* Mozilla Firefox 19+ */
                            color: #666;
                        }
                        input:-ms-input-placeholder,
                        textarea:-ms-input-placeholder {
                            /* Internet Explorer 10+ */
                            color: #666;
                        }
                    }
                    .checkbox-wrap {
                        margin-top: 10px;
                        font-size: 0;
                        .el-checkbox {
                            line-height: 16px;
                            float: left;
                        }
                        .el-checkbox__label {
                            font-size: 12px;
                            color: #666;
                            line-height: 12px;
                        }
                    }
                    .submit-btn {
                        width: 280px;
                        height: 45px;
                        font-size: 16px;
                    }
                }
                .user-error {
                    padding: 0 13px;
                    color: #f04631;
                    width: 264px;
                    font-size: 12px;
                    background: #fff4f2;
                    border: 1px solid #f2d2ce;
                    box-sizing: border-box;
                    height: 36px;
                    width: 280px;
                    margin: 10px 0 10px;
                    .icon-jinggaochacha {
                        margin-right: 7px;
                        font-size: 14px;
                        vertical-align: middle;
                    }
                    .error-text {
                        vertical-align: middle;
                        display: inline-block;
                    }
                }
                .user-no-error {
                    height: 45px;
                }
            }
        }
        .bottom-wrap {
            width: 100%;
            height: 150px;
            background: #fff;
            color: #666;
            text-align: center;
            position: relative;
            .bottom {
                position: absolute;
                bottom: 30px;
                left: 0;
                right: 0;
            }
            .bottom-item {
                width: 330px;
                margin: 0 auto;
                font-size: 0;
            }
            .bottom-text {
                font-size: 12px;
                margin-top: 10px;
            }
            .bottom-link {
                color: #666;
            }
        }
    }

    .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #40515e;
        opacity: 0.4;
    }
}
.password-dialog {
    .el-dialog__body {
        padding: 0;
        .password-icon-tips {
            display: flex;
            align-items: center;
            height: 36px;
            background: #fffaf2;
            border-bottom: 1px solid #f2e3ce;
            border-radius: 3px;
            .el-icon-warning {
                margin-left: 10px;
                font-size: 16px;
                color: #f99b52;
            }
            .tips-text {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #666666;
                letter-spacing: 0;
                line-height: 12px;
                margin-left: 10px;
            }
        }
        .password-passwordForm {
            margin-top: 20px;
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
            }
            .confirm-btn {
                width: 100px;
                height: 32px;
                padding: 0;
                border-radius: 3px;
            }
            .cancle-btn {
                width: 100px;
                height: 32px;
                padding: 0;
                border-radius: 3px;
                margin-left: 20px;
            }
            .form-input {
                width: 330px;
                .el-input__inner {
                    border-radius: 3px;
                    border: 1px solid #dcdcdc;
                    height: 32px;
                    padding: 0 10px;
                }
            }
        }
    }
}
.pass-popover-hover {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 3px;

    .pass-length {
        display: flex;
        align-items: center;
        height: 20px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
        }
    }
    .pass-rule {
        display: flex;
        align-items: flex-start;
        height: 20px;
        padding-bottom: 14px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
            margin-top: 3px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
            margin-top: 3px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
            line-height: 18px;
        }
    }
}
</style>
